import AttendanceAdapter from './base';
import { deleteRecordWithAuditReason } from 'linced-app/utils/auditing';
export default class Record extends AttendanceAdapter {
  modelNamePlural = 'records';
  deleteRecord = deleteRecordWithAuditReason;
}
